import React from 'react'
import { Loader2 } from 'lucide-react'

export interface PaginationProps {
  page: number
  totalPages: number
  onPageChange: (page: number) => void
  disabled?: boolean
  isFetching?: boolean
  prevLabel?: string
  nextLabel?: string
  pageLabel?: string
  ofLabel?: string
  className?: string
}

export const Pagination: React.FC<PaginationProps> = ({
  page,
  totalPages,
  onPageChange,
  disabled = false,
  isFetching = false,
  prevLabel = 'Zurück',
  nextLabel = 'Weiter',
  pageLabel = 'Seite',
  ofLabel = 'von',
  className,
}) => {
  const btnBase =
    'rounded-full bg-[#004494] px-6 py-1.5 text-sm text-white transition-colors hover:bg-[#003070] disabled:opacity-40 disabled:cursor-not-allowed'

  return (
    <div
      className={`flex items-center justify-between px-4 py-3 border border-t-0 border-gray-200 rounded-b-lg bg-white ${className ?? ''}`}
    >
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1 || disabled}
        className={btnBase}
      >
        {prevLabel}
      </button>

      <span className="flex items-center gap-1.5 text-sm text-gray-600">
        {isFetching && (
          <Loader2 size={13} className="animate-spin text-[#004494]" />
        )}
        {totalPages > 0 ? `${pageLabel} ${page} ${ofLabel} ${totalPages}` : '–'}
      </span>

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages || disabled || totalPages === 0}
        className={btnBase}
      >
        {nextLabel}
      </button>
    </div>
  )
}
